<template>
  <div class="sub-domain-sec app-bg-gradient">
    <div class="stars-bg"></div>

    <Languages class="languages" v-bind:settings="false"></Languages>
      <div class="left-sec">
        <img src="/static/images/logo.png" class="logo"/>
        <div class="mosque-name">
          <div class="welcome">{{"WELCOME TO" | translate}}</div>
          <div class="name">{{user.data.name}}</div>
          <!-- <div class="country-name">{{"United Kingdom" | translate}}</div> -->
        </div>
        <div class="navigation">
          <div class="btn-bg1">
            <div class="btn-bg2">
              <button class="cursor login" @click="donationsScreen">{{donationsText | translate}}</button>
            </div>
          </div>
          <div class="btn-bg1">
            <div class="btn-bg2">
              <button class="cursor login" @click="reportsLoginForm">{{reportsText | translate}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="mosque-image-sec">
        <div class="mosque-image">
          <!-- <div class="opacity-white-gradient"></div> -->
          <div class="gradient-dark"></div>
          <div class="ful-visible-image" v-bind:style="{ backgroundImage: 'url('+user.data.image+')'}"></div>
          <div class="opacity-image" v-bind:style="{ backgroundImage: 'url('+user.data.image+')'}"></div>
          <div class="every-pound">
            <!-- <span>{{"Every" | translate}}</span>
            <span>{{"Pound" | translate}}</span>
            <span>{{"Matters" | translate}}</span> -->
            <span>Every</span>
            <span>Pound</span>
            <span>Matters</span>
          </div>
        </div>
      </div>
      <!-- <img :src="user.data.image" class="bg-img"/>
      <div class="back-drop">
      </div>
      <div class="landing-row-sec">
        <div>
          <div class="animated mosque-name zoomIn">{{user.data.name}}</div>
          <br>
        </div>
        <div class="terminal-select-section">
          <div>Select Terminal</div>
          <select name="terminalId" id="terminalId" v-model="terminalId">
            <option v-for="terminal in userPDQTerminals" :key="terminal.tid" :value="terminal.tid">{{terminal.tid}}</option>
          </select>
        </div>
        <div class="donation-button animated zoomIn">
          <button @click="donationsScreen">{{donationsText | translate}}</button>
        </div>
        <div class="reports-button animated zoomIn">
          <button @click="reportsLoginForm">{{reportsText | translate}}</button>
        </div>
        <div class="reports-button animated zoomIn">
          <button @click="showConfigPopup">{{configText | translate}}</button>
        </div>

        <div class="socket-details" v-if="socketDetailsUpdated">
          <div>
            <div>
              <label for="wss-sockethost">WSS socket host name</label>
              <input v-model="wssSocketHost" id="wss-sockethost" name="wss-sockethost" type="text" />
            </div>
            <div>
              <label for="wss-token">WSS Token</label>
              <input v-model="wssToken" id="wss-token" name="wss-token" type="text" />
            </div>
            <div>
              <label for="terminalid">Terminal ID</label>
              <input v-model="terminalID" id="terminalid" name="terminalid" type="text" />
            </div>
            <button @click="setSocketDetails">Set Details</button>
            <div v-if="socketError" class="error">{{socketError}}</div>
          </div>
        </div>
        <div v-if="checkReports" class="reports-login">
            <loginForm class="animated zoomIn"
                v-bind:token="token"
                v-bind:userAction='userAction'
                v-bind:errorMsg='errorMsg'
                :buttonName="btnName"
                @checkUser='checkUser'>
            </loginForm>
        </div>
      </div> -->
      <!--<noTerminals
        @closeNoTerminalsPopup='closeNoTerminalsPopup'
        v-if="noTerminalsAvailable">
      </noTerminals>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Languages from './Languages'
import { apiBaseUrl } from '../api/constants'

// import noTerminals from './No-terminal'

export default {
  name: 'Home',
  data () {
    return {
      donationsText: 'Donations Page',
      reportsText: 'Reports',
      checkReports: false,
      userAction: 'Reports',
      errorMsg: false,
      tasksWaitingForSocketConnection: [],
      noTerminalsAvailable: false,
      btnName: 'Continue',
      socketDetailsUpdated: false,
      wssSocketHost: localStorage.getItem('wss-sockethost') || 'sm958l350000.test.connect.paymentsense.cloud',
      wssToken: localStorage.getItem('wss-token') || '93082359-eede-41fa-9486-c587c72634c6',
      terminalId: null,
      terminalID: localStorage.getItem('terminal-id') || '22162165',
      socketError: false,
      configText: 'Config',
      tid: null,
      replaceRoote: null
    }
  },
  created: function () {
    fetch(`${apiBaseUrl}/terminal-details/${this.$route.params.terminalId}`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('user-store-token')}`
      })
    })
    .then(resp => resp.json())
    .then(res => {
      if (res.status !== 'Failed') {
        this.wssSocketHost = res.wss_url
        this.wssToken = res.token
        this.terminalID = res.tid
        this.socketDetailsUpdated = true

        const socketHost = localStorage.getItem('wss-sockethost')
        const wssToken = localStorage.getItem('wss-token')
        const terminalID = localStorage.getItem('terminal-id')
        const activeTID = localStorage.getItem('user-store-activeTID')

        if (this.wssSocketHost !== socketHost || this.wssToken !== wssToken || this.terminalID !== terminalID || this.terminalID !== activeTID) {
          this.setSocketDetails()
        }
      } else {
        if (this.$route.params.terminalId === '06220842') {
          this.wssSocketHost = 'sm958l350000.test.connect.paymentsense.cloud'
          this.wssToken = '93082359-eede-41fa-9486-c587c72634c6'
          this.terminalID = this.$route.params.terminalId
          this.socketDetailsUpdated = true

          const socketHost = localStorage.getItem('wss-sockethost')
          const wssToken = localStorage.getItem('wss-token')
          const terminalID = localStorage.getItem('terminal-id')
          const activeTID = localStorage.getItem('user-store-activeTID')

          if (this.wssSocketHost !== socketHost || this.wssToken !== wssToken || this.terminalID !== terminalID || this.terminalID !== activeTID) {
            this.setSocketDetails()
          }
        } else {
          localStorage.removeItem('wss-sockethost')
          localStorage.removeItem('wss-token')
          localStorage.removeItem('terminal-id')
          localStorage.removeItem('user-store-activeTID')
        }
      }
    })
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'activeTID',
      'userPDQTerminals',
      'isTerminalAvailable',
      'isConnected',
      'availableTerminals',
      'connectionError',
      'showReportsPopup'
    ])
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'reportsLogin',
      'setActiveTID',
      'requestTerminalDetails',
      'pageRedirect',
      'reprtsPopupShow',
      'reprtsPopupHide'
    ]),
    setSocketDetails () {
      if (this.wssSocketHost && this.wssToken && this.terminalID) {
        localStorage.setItem('wss-sockethost', this.wssSocketHost)
        localStorage.setItem('wss-token', this.wssToken)
        localStorage.setItem('terminal-id', this.terminalID)
        localStorage.setItem('user-store-activeTID', this.terminalID)
        this.socketDetailsUpdated = false
        location.reload()
      } else {
        this.socketError = 'All fields are mandatory'
        setTimeout(() => {
          this.socketError = false
        }, 3000)
      }
    },
    closeNoTerminalsPopup () {
      // this.noTerminalsAvailable = false
    },
    showConfigPopup () {
      this.socketDetailsUpdated = true
    },
    // donationsScreen () {
    //   this.$router.push({name: 'Donations'}, (a) => console.log(arguments))
    // },
    reportsLoginForm () {
      clearTimeout(this.replaceRoote)
      this.$router.push({path: `/${this.tid}/reports`})
    },
    donationsScreen () {
      // this.getTerminalsDetails()
      if (this.isConnected) {
        this.requestTerminalDetails({ socket: this.$socket, terminals: [{tid: this.terminalId}] })
      } else {
        this.tasksWaitingForSocketConnection.push({
          fn: this.requestTerminalDetails,
          params: [ { socket: this.$socket, terminals: [{tid: this.terminalId}] } ]
        })
      }
    },
    getTerminalsDetails () {
      if (this.userPDQTerminals.length > 1) {
        console.log('User has multiple terminals. Choose the terminal you want to use here.')
        // TODO: Handle multiple terminals.
        // this.$router.push({name: 'ChooseTerminal'}, (a) => console.log(arguments))
      } else if (this.isConnected) {
        this.requestTerminalDetails({ socket: this.$socket, terminals: this.userPDQTerminals })
      } else {
        this.tasksWaitingForSocketConnection.push({
          fn: this.requestTerminalDetails,
          params: [ { socket: this.$socket, terminals: this.userPDQTerminals } ]
        })
      }
    }
  },
  watch: {
    isConnected (newValue) {
      if (newValue) {
        while (this.tasksWaitingForSocketConnection.length) {
          let { fn, params } = this.tasksWaitingForSocketConnection.pop()
          fn.apply(this, params)
        }
      }
    },
    showReportsPopup (newValue) {
      this.checkReports = newValue
    },
    connectionError (newValue) {
      if (newValue) {
        alert('Connection error. Please contact support team.')
      }
    },
    userPDQTerminals (newValue) {
      this.terminalId = newValue[0].tid
    },
    isTerminalAvailable (newValue) {
      if (newValue) {
        // Check wether any terminal is available or not.
        if (this.availableTerminals.length === 0) {
          // TODO: Handle no terminals available case.
          // this.noTerminalsAvailable = true
          console.warn('No terminals available. Please restart the PDQ device and login. Contact support team if you still get this issue.')
          this.changeLoadingStatus(false)
        } else if (this.availableTerminals.length === 1) {
          console.log('User has only one terminal and using that to show donations page.')
          this.setActiveTID(this.availableTerminals[0])
          this.$router.push({path: `/${this.tid}/donations`})
          // this.$router.push({name: 'Donations'}, (a) => console.log(arguments))
        }
      }
    }
  },
  components: {
    Languages
    // noTerminals
  },
  mounted: function () {
    this.checkReports = this.showReportsPopup
    this.tid = this.$route.params.terminalId
    clearTimeout(this.replaceRoote)
    this.replaceRoote = setTimeout(() => {
      this.donationsScreen()
      // this.$router.push({path: `/${this.tid}/donations`})
    }, (1000 * 60 * 5))
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
        this.terminalId = this.$route.params.terminalId
        this.changeLoadingStatus(false)
        window.document.title = this.user.data.name
      }
    })
    this.pageRedirect('reload')
  },
  destroyed: function () {
    clearTimeout(this.replaceRoote)
  },
  beforeDestroy: () => {
    clearTimeout(this.replaceRoote)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  z-index: 3;
}
    .sub-domain-sec {
      width: 100%;
      height: 100vh;
      padding: 0 68px;
      position: relative;
      display: flex;
    }
    .gradient-dark {
      background: rgba(254,158,85,0.84);
      background: -moz-linear-gradient(top, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
      background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(254,158,85,0.84)), color-stop(100%, rgba(202,61,89,0.84)));
      background: -webkit-linear-gradient(top, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
      background: -o-linear-gradient(top, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
      background: -ms-linear-gradient(top, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
      background: linear-gradient(to bottom, rgba(254,158,85,0.84) 0%, rgba(202,61,89,0.84) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fe9e55', endColorstr='#ca3d59', GradientType=0 );
      width: 100%;
      height: 100%;
    }
    .stars-bg {
      background-image: url('/static/images/background-stars.png');
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
    .logo {
      width: 170px;
      margin-top: 11px;
    }
    .welcome {
      font-size: 22px;
      color: rgba(42, 42, 42, 0.8);
      font-weight: 600;
      letter-spacing: 2px;
      padding-left: 8px;
    }
    .mosque-name {
      padding-left: 40px;
    }
    .mosque-name div.name{
      font-size: 40px;
      color: #FFF;
      font-family: "Lato";
      font-weight: bold;
      text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
      letter-spacing: 2px;
      line-height: 60px;
    }
    .country-name {
      font-size: 20px;
      color: #FFF;
      font-family: "Lato";
      font-weight: bold;
      text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
      margin-top: 16px;
      text-align: right;
      letter-spacing: 2px;
    }
    .left-sec {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 120px;
    }
    .mosque-image {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;
      border-radius: 50%;
      height: 95%;
      margin-top: 1.5%;
    }
    .mosque-image img {
      opacity: 0.2;
    }
    .ful-visible-image {
      width:70%;
      height: 70%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      border-radius: 100%;
      background-position: center;
    }
    .opacity-image {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      border-radius: 100%;
      background-position: center;
      opacity: 0.19;
    }
    .opacity-image {
      background-size: 100% 100%;
    }
    .ful-visible-image {
      background-size: 143% 143%;
    }
    .opacity-white-gradient {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      border-radius: 100%;
      background-position: center;
      opacity: 0.5;
      background-color: white;
    }

    .navigation {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      /* align-items: center;
      justify-content: center; */
    }
    .reports-login {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto auto;
      z-index: 11;
      max-width: 365px;
      display: flex;
      align-items: center;
      justify-content: center;
      max-height: 450px;
    }
    .btn-bg1 {
      margin: inherit;
      margin-left: 30px;
      margin-top: 0;
    }
    .every-pound {
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #FFF;
      font-size: 22px;
      line-height: 28px;
      font-family: 'Cinzel', serif;
    }
    .every-pound span:not(:last-child) {
      border-bottom: 1px solid #ceb4bb;
    }
    .every-pound span:first-child {
      padding: 0 40px;
    }
    .every-pound span:nth-child(2) {
      padding: 0 20px;
    }
    .mosque-image-sec {
      width:50%;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @media only screen and (min-width: 2000px) {
      .left-sec {
        width: 40%;
      }
      .mosque-image-sec {
        width:60%;
      }
      .mosque-image {
        max-height: 60%;
      }
      .logo {
        width: 660px;
        margin-top: 10%;
        margin-left: 5%;
      }
      .welcome {
        font-size: 100px;
        padding-left: 5%;
      }
      .mosque-name {
        margin-top: 30%;
      }
      .mosque-name div.name {
        font-size: 140px;
        line-height: 180px;
        padding-left: 3%;
        margin-top: 60px;
      }
      .btn-bg1 {
        margin-left: 2%;
        width: 490px;
      }
      .btn-bg2 {
        width: 480px;
      }
      button.login {
        width: 470px;
      }
      .navigation {
        margin-bottom: 30%;
      }
      .every-pound {
          font-size: 90px;
          line-height: 122px;
      }
      .reports-login {
        top: 30%;
        bottom: initial;
        max-height: initial !important;
        max-width: 45vw;
      }
    }
  @media screen and (min-width: 1200px) and (min-height: 904px) {
    .left-sec {
      width: 40%;
    }
    .mosque-image-sec {
      width: 60%;
    }
    .mosque-image {
      width: 95%;
      height: 55vw;
    }
    .every-pound {
      line-height: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue